import { t } from '@lingui/core/macro';
import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';

type Props = {
  onClose: VoidFunction;
  isLoading: boolean;
};

export const FormCancelAndSaveButtons = ({ onClose, isLoading }: Props) => {
  return (
    <Stack direction="row" gap={2} justifyContent="flex-end">
      <Button variant="contained" color="inherit" onClick={onClose}>
        {t`Annuler`}
      </Button>
      <LoadingButton variant="contained" type="submit" loading={isLoading}>
        {t`Sauvegarder`}
      </LoadingButton>
    </Stack>
  );
};
